import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TdLoadingService, TdDialogService } from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { AlergiasService, MasterService, LoginService } from '../../../../services/';

import { Alergia } from '../../../../models';

@Component({
    selector: 'qs-alergiasdetalle',
    styleUrls: ['./alergiasdetalle.component.scss'],
    templateUrl: './alergiasdetalle.component.html',
    viewProviders: [AlergiasService, MasterService],
})

export class AlergiasDetalleComponent implements AfterViewInit, OnDestroy {

    private mode: string;
    private title: string;

    private alergia: Alergia;
    private oldAlergia: Alergia;
    private estadosAlergia: any[];
    private tiposAlergia: any[];
    private filtrando: boolean = false;
    private accion: string;
    private idPaciente: string;
    private visita: string;
    private dniMedico: string;
    private descripcion: string;
    private cip: string;
    private codigo: any;

    public masterPrincipiosActivos: any[];
    public valuePrincipioActivo: any[];
    public filteredPrincipiosActivos: any[];
    public asignedPrincipiosActivos: any[];
    public addPrincipiosActivos: boolean = true;
    public delPrincipiosActivos: boolean = true;

    constructor(private _loadingService: TdLoadingService,
        private _dialogService: TdDialogService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _master: MasterService,
        private _alergiasService: AlergiasService,
        private _loginService: LoginService,
        private _changeDetectorRef: ChangeDetectorRef) {
        this.alergia = new Alergia();
        this.oldAlergia = new Alergia();
        this.visita = this._loginService.consulta.visita;
        this.idPaciente = this._loginService.consulta.numeroExpediente;
        this.dniMedico = this._loginService.profesional.Dni;
        this.cip = this._loginService.consulta.cip;
        if (this._loginService.transient) {
            this.mode = 'edit';
            this.title = 'Editar';
            this.alergia = this._loginService.transient;
            this.oldAlergia = this._loginService.transient;
            this.asignedPrincipiosActivos = [this.alergia.cpfNombreComponente];
            this.valuePrincipioActivo = [{ id: this.alergia.cpfIdComponente, nombre: this.alergia.cpfNombreComponente }];
            this.addPrincipiosActivos = false;
            this.delPrincipiosActivos = false;
        } else {
            this.mode = 'add';
            this.title = 'Añadir';
            this.alergia.fecha = new Date();
            this.oldAlergia.fecha = new Date();
        }
    }

    ngAfterViewInit(): void {
        this._loadingService.register('alergia.load');
        this._master.obtenerMasterAlergias().subscribe((res: any) => {
            if (!res.error) {
                this.tiposAlergia = res.respuesta.alergias || [];
                this._loadingService.resolve('alergia.load');
            } else {
                this._loginService.mostrarMensaje(res.error.mensaje, 'OK', 3000);
                this._loadingService.resolve('alergia.load');
            }
        }, (error: Error) => {
            this.filtrando = false;
        });
        this._master.obtenerMasterEstadosAlergias().subscribe((res: any) => {
            this.estadosAlergia = res.estados;
        });
        this._changeDetectorRef.detectChanges();
    }

    getPrincipiosActivos(value: string): void {
        if (value.length >= 3) {
            this.filtrando = true;
            this._master.obtenerPrincipiosActivos(value).subscribe((res: any) => {
                if (!res.error) {
                    this.masterPrincipiosActivos = res.respuesta.principiosActivos || [];
                    this.filteredPrincipiosActivos = this.masterPrincipiosActivos.map((pa: any, index: any, pas: any[]) => {
                        return pa.nombre;
                    });
                    this.asignedPrincipiosActivos = this.filteredPrincipiosActivos;
                    this.filtrando = false;
                } else {
                    this._loginService.mostrarMensaje(res.error.mensaje, 'OK', 3000);
                    this.filtrando = false;
                }
            }, (error: Error) => {
                this.filtrando = false;
            });
        }
    }

    addPrincipioActivo(value: any): void {
        this.addPrincipiosActivos = false;
        this.valuePrincipioActivo = this.masterPrincipiosActivos.filter((pa: any) => { return pa.nombre === value; });
        this.masterPrincipiosActivos = undefined;
        this.filteredPrincipiosActivos = undefined;
        this.filtrando = false;
    }

    removePrincipioActivo(value: any): void {
        this.masterPrincipiosActivos = undefined;
        this.filteredPrincipiosActivos = undefined;
        this.valuePrincipioActivo = undefined;
        this.asignedPrincipiosActivos = undefined;
        this.addPrincipiosActivos = true;
        this.filtrando = false;
    }

    borrarAlergia(form: NgForm): void {
        this.mode = 'del';
        this.save(form);
    }

    save(form: NgForm): void {
        let params: any;
        let fecha: Date = new Date();
        let message: string = '';
        let error: string = '';
        let messages: string[] = [
            'Alergia añadida correctamente.', 'Error añadiendo Alergia.',
            'Alergia actualizada correctamente.', 'Error actualizando Alergia.',
            'Alergia borrada correctamente.', 'Error borrando Alergia', ];
        let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
        switch (this.mode) {
            case 'edit':
                this.accion = 'M';
                message = messages[2];
                error = message[3];
                break;
            case 'add':
                this.accion = 'I';
                message = messages[0];
                error = messages[1];
                break;
            case 'del':
                this.accion = 'B';
                message = messages[4];
                error = messages[5];
                break;
            default: break;
        }

        let codigo: any[] = this.tiposAlergia.filter((tipo: any) => {
            return tipo.id === this.alergia.codigo;
        });

        if (form.valid) {
            this._loadingService.register();
            switch (this.mode) {
                case 'add':
                    params = {
                        cip: this.cip,
                        idAlergusu: this.accion !== 'I' ? this.alergia.idAlergiaUsuario : '',
                        contador: this.idPaciente,
                        codigo: codigo[0].id,
                        descripcion: codigo[0].nombre,
                        numVisita: this.visita,
                        sospecha: this.alergia.sospecha,
                        medicamento: this.valuePrincipioActivo !== undefined ? this.valuePrincipioActivo[0].id : '',
                        desalergia: codigo[0].nombre,
                        dniMed: this._loginService.profesional.Dni,
                        idModulo: 0,
                    };
                    this._alergiasService.guardarAlergia(params).subscribe((res: any) => {
                        if (res) {
                            this.mode = 'save';
                            this._loginService.mostrarMensaje(message, 'OK', 6000);
                            this._loadingService.resolve();
                            this._router.navigate(['/main/consulta/' + this.idPaciente + '/alergias']);
                        } else {
                            this._loginService.mostrarMensaje(message, 'OK', 6000);
                            this._loadingService.resolve();
                        }
                    }, (resError: Error) => {
                        this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
                        this._loadingService.resolve();
                    });
                    break;
                case 'edit':
                    // Modo edit
                    params = {
                        idAlergusu: this.alergia.idAlergiaUsuario,
                        contador: this.idPaciente,
                        sospecha: this.alergia.sospecha,
                        dniBorrado: '',
                    };
                    this._alergiasService.cambiarEstadoAlergia(params).subscribe((res: any) => {
                        if (res) {
                            this.mode = 'save';
                            this._loginService.mostrarMensaje(message, 'OK', 6000);
                            this._loadingService.resolve();
                            this._router.navigate(['/main/consulta/' + this.idPaciente + '/alergias']);
                        } else {
                            this._loginService.mostrarMensaje(message, 'OK', 6000);
                            this._loadingService.resolve();
                        }
                    }, (resError: Error) => {
                        this._loginService.mostrarMensaje('Error procesando la modificación.', 'OK', 6000);
                        this._loadingService.resolve();
                    });
                    break;
                case 'del':
                    // Modo delete
                    params = {
                        idAlergusu: this.alergia.idAlergiaUsuario,
                        dniBorrado: this._loginService.profesional.Dni,
                        motivoBorrado: 'HCIOnCloud',
                    };
                    this._alergiasService.borrarAlergia(params).subscribe((res: any) => {
                        if (res) {
                            this.mode = 'save';
                            this._loginService.mostrarMensaje(message, 'OK', 6000);
                            this._loadingService.resolve();
                            this._router.navigate(['/main/consulta/' + this.idPaciente + '/alergias']);
                        } else {
                            this._loginService.mostrarMensaje(message, 'OK', 6000);
                            this._loadingService.resolve();
                        }
                    }, (resError: Error) => {
                        this._loginService.mostrarMensaje('Error procesando el borrado.', 'OK', 6000);
                        this._loadingService.resolve();
                    });
                    break;
                default: break;
            }
        }
    }

    canDeactivate(): Promise<boolean> | boolean {
        if (this.oldAlergia.cpfNombreComponente === this.alergia.cpfNombreComponente) {
            return true;
        } else {
            if (this.mode !== 'save') {
                return new Promise((resolve: any) => {
                    this._dialogService.openConfirm({
                        message: 'Si pulsa aceptar, se perderán los datos introducidos.',
                        title: '¿Desea abandonar el alta de alergia?',
                        acceptButton: 'Aceptar',
                        cancelButton: 'Cancelar',
                    }).afterClosed().subscribe((accept: boolean) => {
                        if (accept) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    });
                });
            } else {
                return true;
            }
        }
    }

    ngOnDestroy(): void {
        this._loginService.transient = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/consulta/alergias/alergiasdetalle/alergiasdetalle.component.ts